import React from "react";
import "./LoadingScreen.css";

/**
 * Animated logo cube SVG
 * Extracted from Logo.js for loading screen use
 */
const AnimatedLogoCube = () => (
  <svg
    className="loading-logo-svg"
    width="80"
    height="80"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0" y="0" width="28" height="28" rx="5" fill="#EB5939" />
    <g className="loading-eyes">
      <circle cx="8" cy="10" r="3" fill="#e9e1d7" />
      <circle cx="20" cy="10" r="3" fill="#e9e1d7" />
    </g>
  </svg>
);

/**
 * LoadingScreen - Displays animated logo and progress bar during asset preload
 *
 * @param {number} progress - Loading progress (0-100)
 */
const LoadingScreen = ({ progress = 0 }) => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-logo">
          <AnimatedLogoCube />
        </div>

        <div className="loading-progress">
          <div className="loading-bar">
            <div
              className="loading-bar-fill"
              style={{ width: `${progress}%` }}
            />
          </div>
          <span className="loading-text">
            {progress}%<span className="blinking-cursor">|</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
